import Rest from '../Services/Rest'

/**
 * @typedef {PacatoService}
 */
export default class PacatoService extends Rest {
    /**
     * @type {String}
     */
    static resource = '/pacato'

    configs(){
        return this.get("/configs");
    }
}